import React, { useEffect, useState } from 'react'

import { Box, Button, Grid, TextField, Typography } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import ReCAPTCHA from 'react-google-recaptcha'

import { LoadingFeedback } from 'components'

import useGuestJourney from 'hooks/useGuestJourney'
import useSnackbar from 'hooks/useSnackbar'

import { getGoogleRecaptchaToken } from 'service/env'
import * as service from 'service'
import useStyles from './styles'

const EmailStep = () => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)

  const { handleSubmit, control, errors } = useFormContext()
  const {
    accessToken,
    companyInfo,
    disableRecaptcha,
    guestModule,
    handleAcceptedRecaptcha,
    handleNext,
    portalToken,
    recaptcha,
    recaptchaRef,
    resetRecaptcha,
    setAccessToken,
    setUser,
    user,
  } = useGuestJourney()

  const publicPath = window.location.origin + window.location.pathname

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      const response = await service.guestPortal.company.validateEmail(
        portalToken,
        data.email,
        guestModule,
        publicPath,
        recaptcha,
      )

      setUser(response?.data?.user)
      setAccessToken(response?.data?.accessToken)
    } catch (error) {
      snackbar.open({
        message:
          'Parece que seu e-mail ainda não está autorizado. Entre em contato com o DPO ou Representante da sua organização para solicitar o acesso.',
        variant: 'error',
      })
    } finally {
      resetRecaptcha()
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!user || !accessToken) return
    handleNext()
    // eslint-disable-next-line
  }, [!!user, !!accessToken])

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <form
        id="form-register"
        className={classes.form}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={8}>
            <Typography color="primary" className={classes.title}>
              {companyInfo?.name}
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography color="primary" className={classes.subtitle}>
              Identifique-se com seu e-mail. Enviaremos um código de verificação
              para o e-mail informado. Apenas e-mails autorizados podem acessar
              o portal.
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Controller
              as={
                <TextField
                  fullWidth
                  variant="outlined"
                  label="E-mail"
                  type="email"
                  error={!!errors?.email}
                  helperText={errors?.email?.message}
                />
              }
              name="email"
              control={control}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <Box className={classes.formFooter}>
              <ReCAPTCHA
                ref={recaptchaRef}
                render="explicit"
                sitekey={getGoogleRecaptchaToken()}
                onChange={handleAcceptedRecaptcha}
                onExpired={disableRecaptcha}
              />
              <Button
                form="form-register"
                type="submit"
                variant="contained"
                color="secondary"
                disabled={!recaptcha}
                className={classes.submitButton}
              >
                Avançar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default EmailStep
